<template>
  <div class="search-in">
    <div class="close-button" @click="onCancele">
      <i class="el-icon-circle-close"></i>
    </div>
    <div class="search-in-title">港口船舶实时查询分析</div>
    <el-form ref="form" :model="formUpdateData">
      <el-form-item style="margin-left: -10px" label="港口选择" class="form-item" required>
        <el-select
          v-model="selectPort"
          style="width: 250px"
          filterable
          remote
          :remote-method="remoteMethod"
          placeholder="请输入港口名称（至少2个字符）"
          clearable
          :loading="loading"
        >
          <el-option
            v-for="item in internalPortList"
            :key="item.id"
            :label="'英文名：' + item.name + ' 中文名：' + item.cnName"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="large" style="text-align: center; margin-top: 30px">
        <el-button id="btn-confirm" type="primary" @click="onSubmit" style="width: 100px"
          >查询</el-button
        >
        <el-button id="btn-cancel" style="margin-left: 30px; width: 100px" @click="onCancele"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getPortListByName } from "@/utils/api/index";

export default {
  name: "portSelector",
  data() {
    return {
      formUpdateData: null,
      selectPort: "",
      loading: false,
      searchTimer: null,
      internalPortList: [], // 内部维护的港口列表
    };
  },
  methods: {
    remoteMethod(query) {
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // 如果输入少于2个字符，清空列表
      if (query && query.length < 2) {
        this.internalPortList = [];
        return;
      }

      // 如果输入为空，清空列表
      if (!query) {
        this.internalPortList = [];
        return;
      }

      // 防抖处理，延迟300ms执行
      this.searchTimer = setTimeout(() => {
        this.loading = true;
        getPortListByName(query)
          .then((response) => {
            this.loading = false;
            if (response.data && response.data.resultCode === 0 && response.data.resultData) {
              // 更新内部列表
              this.internalPortList = response.data.resultData;
            } else {
              this.internalPortList = [];
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error("查询港口列表失败:", error);
            this.internalPortList = [];
            this.$message({
              message: "查询港口列表失败，请重试",
              type: "error",
              duration: 1600,
            });
          });
      }, 300);
    },
    onSubmit() {
      console.log("submit: " + " selectPort: " + this.selectPort);

      if (this.selectPort == null || this.selectPort === "" || this.selectPort === " ") {
        this.$message({
          message: "港口不能为空！",
          type: "error",
          duration: 1600,
        });
        return;
      }

      let item;
      this.internalPortList.forEach((element) => {
        if (element.name == this.selectPort) {
          item = element;
        }
      });
      console.log(item);

      this.$emit("newPortInit", item);
    },
    onCancele() {
      this.$emit("onPortSelectorCancel");
    },
    selectChange(value) {
      this.selectPort = value;
    },
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
};
</script>

<style scoped lang="less">
.search-in {
  width: 340px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: -5px 0 3px -1px gray, 0 -2px 3px -1px gray, 0 2px 3px -1px gray, 2px 0 3px -1px gray;

  color: white;
  position: absolute;
  top: 0;
  left: 0;
  padding: 30px 30px;
  padding-top: 40px;

  #btn-confirm {
    background-color: #165184;
    border-color: #165184;
  }

  #btn-cancel {
    background-color: #3c3d3f;
    border-color: #3c3d3f;
    color: white;
  }

  .search-in-title {
    text-align: center;
    font-size: 15pt;
    //color: white;
    margin-bottom: 20px;
    margin-top: 5px;
  }

  /deep/ .el-form-item__label {
    font-size: 12pt;
    color: #7cd8da;
  }

  .form-item {
    margin-top: 30px;
  }

  .close-button {
    position: absolute;
    top: 3px;
    right: 5px;
    z-index: 9277;
    font-size: 25px;
    color: #fff;
  }
}
</style>
